import "react-app-polyfill/ie11"
import 'core-js'
import "regenerator-runtime/runtime"
import React from "react"
import { render } from "react-dom"
import App from "./App"
import "./components/styles/index.css"


render(<App />, document.getElementById("app"))
